var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 28,
    fill: "none",
    className: "social-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "facebook",
    clipPath: "url(#clip0_3601_1138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fill: "currentColor",
    d: "M26.58 14.26a13.08 13.08 0 1 0-15.12 12.92v-9.14H8.13v-3.78h3.33v-2.89c0-3.27 1.95-5.08 4.94-5.08 1.43 0 2.92.25 2.92.25v3.22h-1.65c-1.62 0-2.13 1-2.13 2.04v2.46h3.63l-.58 3.78h-3.05v9.14a13.08 13.08 0 0 0 11.04-12.92Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3601_1138"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 .76h27v27H0z"
  })))));
};
export default SvgFacebook;